import type en from "../en/ui";
import type { Messages } from "../../types";

const ar: Messages<typeof en> = {
  optional: "(اختياري)",
  breadcrumb: "مسار التنقل",
  tabs: "علامات التبويب",
  pagination: "التنقل بين الصفحات",
  results: "{count} نتيجة",
  results_zero: "لا توجد نتائج",
  results_one: "نتيجة واحدة",
  results_two: "نتيجتان",
  results_few: "{count} نتائج",
  results_many: "{count} نتيجة",
  pageSummary: "الصفحة {page} من {pages} · عدد النتائج: {total}",
  working: "جارٍ التنفيذ…",
  reason: "السبب",
  uploadFailed: "تعذّر الرفع",
  uploadHintPrivate: "ملفات PDF أو ZIP أو EPUB أو MP3 أو MP4 بحجم أقصاه 100 ميغابايت — تُخزَّن بشكل خاص",
  uploadHintPublic: "صور PNG أو JPEG أو WebP أو GIF أو AVIF بحجم أقصاه 10 ميغابايت",
  status_active: "نشط",
  status_inactive: "غير نشط",
  status_published: "منشور",
  status_paid: "مدفوع",
  status_unpaid: "غير مدفوع",
  status_partially_paid: "مدفوع جزئيًا",
  status_captured: "تم التحصيل",
  status_fulfilled: "تم التنفيذ",
  status_unfulfilled: "لم يُنفَّذ",
  status_partially_fulfilled: "منفَّذ جزئيًا",
  status_succeeded: "ناجح",
  status_connected: "متصل",
  status_disconnected: "غير متصل",
  status_verified: "تم التحقق",
  status_completed: "مكتمل",
  status_complete: "مكتمل",
  status_delivered: "تم التسليم",
  status_approved: "موافق عليه",
  status_refunded: "مسترد",
  status_partially_refunded: "مسترد جزئيًا",
  status_draft: "مسودة",
  status_archived: "مؤرشف",
  status_cancelled: "ملغى",
  status_canceled: "ملغى",
  status_closed: "مغلق",
  status_not_required: "غير مطلوب",
  status_expired: "منتهي الصلاحية",
  status_pending: "قيد الانتظار",
  status_awaiting_action: "بانتظار إجراء",
  status_awaiting_confirmation: "بانتظار التأكيد",
  status_requested: "مطلوب",
  status_setup_required: "يتطلب الإعداد",
  status_open: "مفتوح",
  status_resolved: "تم الحل",
  status_in_progress: "قيد التنفيذ",
  status_authorized: "مصرّح به",
  status_received: "مستلم",
  status_processed: "تمت المعالجة",
  status_processing: "قيد المعالجة",
  status_ignored: "تم التجاهل",
  status_trialing: "فترة تجريبية",
  status_shipped: "تم الشحن",
  status_failed: "فشل",
  status_error: "خطأ",
  status_disputed: "متنازع عليه",
  status_suspended: "موقوف",
  status_rejected: "مرفوض",
  status_reauth_required: "يلزم إعادة الربط",
  status_past_due: "متأخر السداد",
  status_incomplete: "غير مكتمل",
  status_chargeback: "استرداد مصرفي",
  status_urgent: "عاجل",
  status_high: "مرتفعة",
  status_normal: "عادية",
  status_low: "منخفضة",
  status_void: "ملغاة",
  status_uncollectible: "غير قابلة للتحصيل",
  status_queued: "في قائمة الانتظار",
  status_running: "قيد التشغيل",
  status_done: "تم",
  status_sent: "مُرسل",
  status_logged: "مُسجَّل",
  status_suppressed: "محظور",
  status_unknown: "غير معروف",
  status_converted: "تم التحويل",
  status_missing: "مفقود",
  status_partial: "جزئي",
  status_outdated: "قديم",
  status_undone: "تم التراجع",
  status_scheduled: "مجدول",
};

export default ar;
